<template>
  <Modal :id="id" title="Change Enrollment Brand" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <Field
              type="select"
              name="enrollment_brand"
              label="Choose a Brand"
              :options="brands"
              v-model="brand"
              :hide-select-empty-option="true"
            />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Update</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "edit-cart-brand-modal",
      enrollment: null,
      brands: [],
      brand: null,
    };
  },
  methods: {
    save() {
      var route = (this.type === "App\\Models\\Courses\\Course") ? "enroll.online.cart.brand" : "enroll.classroom.cart.brand";
      var url = this.route(route, {
        type: this.enrollment.item_type.replace("_", "-"),
        enrollment: this.enrollment.id,
      });
      this.axios.post(url, { brand: this.brand }).then(() => {
        this.resolve();
      });
    },
  },
  created() {
    this.enrollment = _.cloneDeep(this.options.enrollment);
    this.brand = this.enrollment.brand_id;
    this.brands = this.enrollment.enrollable_brands;

    this.type = this.enrollment.enrollable_type;
  },
};
</script>